<div class="sle-editor">

    @if (description) {
        <p class="sle-desc">{{ description }}</p>
    }
    @if (isReadOnly) {
        <p class="sle-readonly-hint">
            <mat-icon class="sle-lock-icon">lock</mat-icon>
            Read-only — defined on the UserDataType
        </p>
    }

    <div class="sle-body" [class.sle-readonly]="isReadOnly">
        <ng-container [ngSwitch]="widget()">

            <!-- ── string (free-text) ── -->
            <mat-form-field *ngSwitchCase="'text'" appearance="outline" class="sle-field" subscriptSizing="dynamic">
                <mat-label>{{ label }}</mat-label>
                <input matInput [formControl]="control" [placeholder]="placeholder" />
                <mat-error *ngIf="control.hasError('minlength')">Min {{ schema.minLength }} chars</mat-error>
                <mat-error *ngIf="control.hasError('maxlength')">Max {{ schema.maxLength }} chars</mat-error>
                <mat-error *ngIf="control.hasError('pattern')">Pattern mismatch</mat-error>
            </mat-form-field>

            <!-- ── string (enum) ── -->
            <mat-form-field *ngSwitchCase="'enum'" appearance="outline" class="sle-field" subscriptSizing="dynamic">
                <mat-label>{{ label }}</mat-label>
                <mat-select [formControl]="control">
                    @for (opt of schema.enum; track opt) {
                        <mat-option [value]="opt">{{ opt }}</mat-option>
                    }
                </mat-select>
            </mat-form-field>

            <!-- ── string + userdata-* autocomplete ── -->
            <mat-form-field *ngSwitchCase="'autocomplete'" appearance="outline" class="sle-field" subscriptSizing="dynamic">
                <mat-label>{{ label }}</mat-label>
                <input matInput [formControl]="control" [placeholder]="placeholder" [matAutocomplete]="acAuto" />
                <mat-autocomplete #acAuto="matAutocomplete">
                    @for (opt of filteredOptions(); track opt) {
                        <mat-option [value]="opt">{{ opt }}</mat-option>
                    }
                </mat-autocomplete>
            </mat-form-field>

            <!-- ── string + userdata catalog picker ── -->
            <div *ngSwitchCase="'userdata-picker'" class="sle-field">
                <app-user-data-picker
                        [type]="userDataPickerType"
                        [label]="label"
                        [value]="control.value"
                        (valueChange)="control.setValue($event)"
                        [placeholder]="placeholder" />
            </div>

            <!-- ── string + connector-catalog placeholder ── -->
            <mat-form-field *ngSwitchCase="'connector-catalog'" appearance="outline" class="sle-field" subscriptSizing="dynamic">
                <mat-label>{{ label }}</mat-label>
                <input matInput [formControl]="control" [placeholder]="placeholder" />
                <mat-icon matSuffix
                          matTooltip="Connector catalog service is not yet shipped — free-text for now."
                          class="sle-warn-icon">info_outline</mat-icon>
            </mat-form-field>

            <!-- ── integer / number ── -->
            <mat-form-field *ngSwitchCase="'number'" appearance="outline" class="sle-field" subscriptSizing="dynamic">
                <mat-label>{{ label }}</mat-label>
                <input matInput type="number" [formControl]="control"
                       [min]="schema.minimum ?? null" [max]="schema.maximum ?? null"
                       [placeholder]="placeholder" />
                <mat-error *ngIf="control.hasError('min')">Min {{ schema.minimum }}</mat-error>
                <mat-error *ngIf="control.hasError('max')">Max {{ schema.maximum }}</mat-error>
            </mat-form-field>

            <!-- ── boolean ── -->
            <div *ngSwitchCase="'boolean'" class="sle-toggle">
                <mat-slide-toggle [formControl]="control" color="primary">
                    {{ label }} · {{ control.value ? 'On' : 'Off' }}
                </mat-slide-toggle>
            </div>

            <!-- ── array of primitives — chip input ── -->
            <mat-form-field *ngSwitchCase="'array'" appearance="outline" class="sle-field" subscriptSizing="dynamic">
                <mat-label>{{ label }}</mat-label>
                <mat-chip-grid #chipGrid [formControl]="control">
                    @for (item of arrayValue(); track item) {
                        <mat-chip-row (removed)="arrayRemove(item)">
                            {{ item }}
                            <button matChipRemove [attr.aria-label]="'Remove ' + item">
                                <mat-icon>cancel</mat-icon>
                            </button>
                        </mat-chip-row>
                    }
                </mat-chip-grid>
                <input [placeholder]="placeholder || 'Add and press Enter…'"
                       [matChipInputFor]="chipGrid"
                       [matChipInputSeparatorKeyCodes]="chipSeparators"
                       (matChipInputTokenEnd)="arrayAdd($event)" />
            </mat-form-field>

        </ng-container>
    </div>

</div>
